<div class="devops-kpis" data-testid="devops-kpis">
  @for (kpi of kpis; track kpi.labelKey) {
    <app-kpi-card
      [label]="kpi.labelKey | translate"
      [value]="kpi.value"
      [suffix]="kpi.suffix"
      [icon]="kpi.icon"
      [iconColorVar]="kpi.iconColorVar"
      [sparkline]="kpi.sparkline"
    />
  }
</div>
